import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  text: 'El Módulo 3 fue el más importante para mí. Nunca nadie me había explicado tan claramente el significado de las flores y los elementos. Lo leí subrayando cada página.',
  name: 'Cecilia R.',
  city: 'Mendoza'
}, {
  initials: 'SC',
  text: 'Soy de las que empieza y abandona. Pero el atlas es tan visual que terminé los 8 módulos en una semana. Las referencias del Bonus 1 las uso todos los días para mis diseños.',
  name: 'Sofía C.',
  city: 'La Plata'
}, {
  initials: 'PA',
  text: 'El bonus de mitología me abrió los ojos. Identifiqué criaturas que llevaba años viendo en tatuajes sin entender. Ahora aprecio el irezumi de otra manera.',
  name: 'Paula A.',
  city: 'Neuquén'
}, {
  initials: 'JM',
  text: 'El Módulo 5 sobre composición corporal fue clave. Llevaba meses pensando en mi manga y no sabía cómo estructurarla. Empecé a aplicar las reglas y todo encajó.',
  name: 'Julia M.',
  city: 'Rosario'
}, {
  initials: 'MV',
  text: 'Compré la colección completa. El diccionario visual fue lo mejor. Tengo un tatuador muy tradicional y antes no sabía cómo pedirle lo que quería. Ahora hablamos el mismo idioma.',
  name: 'María V.',
  city: 'Tucumán'
}, {
  initials: 'GR',
  text: 'Lo que más me impactó fue el Módulo 7 con la galería maestra. Cada composición era una obra de arte. Ver las piezas completas me dio inspiración para mi propia espalda.',
  name: 'Gabriela R.',
  city: 'Santa Fe'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-339">
      <div className="max-w-6xl mx-auto" data-id="element-340">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-341">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-342">
            <span className="text-xs font-bold tracking-widest" data-id="element-343">
              ❤️ PERSONAS QUE AMAN LA CULTURA JAPONESA
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-344">
            Lectores que ya empezaron a descubrir el{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-345">
              irezumi
            </span>
          </h2>
          <div className="flex flex-col items-center gap-2 mt-6" data-id="element-346">
            <div className="flex gap-1" data-id="element-347">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-rose text-rose" data-id="element-348" />)}
            </div>
            <div className="text-sm text-ink-soft" data-id="element-349">
              <strong data-id="element-350">4.8/5</strong> · basado en{' '}
              <strong className="text-rose" data-id="element-351">+XXX</strong> opiniones
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-352">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06,
          duration: 0.5
        }} className="bg-bg-warm border border-line rounded-3xl p-6 shadow-sm" data-id="element-353">
              <div className="flex items-center gap-3 mb-4" data-id="element-354">
                <div className="w-11 h-11 rounded-full bg-rose text-white flex items-center justify-center font-bold font-serif text-sm" data-id="element-355">
                  {t.initials}
                </div>
                <div className="flex gap-0.5" data-id="element-356">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-rose text-rose" data-id="element-357" />)}
                </div>
              </div>
              <p className="font-serif-italic text-ink leading-relaxed mb-4" data-id="element-358">
                "{t.text}"
              </p>
              <div className="text-sm font-semibold text-ink pt-4 border-t border-line" data-id="element-359">
                {t.name}{' '}
                <span className="text-muted font-normal" data-id="element-360">— {t.city}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}